import capitalize from './capitalize'

export default (
	s: string,
	omit: string[] = ['de', 'la', 'el', 'a', 'y', 'del']
) =>
	s
		.split('-')
		.map((word) => (!omit.includes(word) ? capitalize(word) : word) + ' ')
		.join(' ')
